import PackageSearchResults from './PackageSearchResults';

export default PackageSearchResults;
